import styled from 'styled-components';
import { pxToRem } from '../../../../utils/pxToRem';
import delete_icon from '../../../../assets/delete_icon.svg';
import { FC } from 'react';
import { IAdmin } from '../../../../store/admin/interface';

type IAdminCard = {
  handleDelete?: () => void;
  admin: IAdmin;
  className?: string;
  hideDelete?: boolean;
};

export const AdminCard: FC<IAdminCard> = ({
  className,
  handleDelete,
  hideDelete,
  admin
}) => {
  return (
    <Card className={className}>
      {!hideDelete && (
        <DeleteBtn onClick={handleDelete}>
          <Icon src={delete_icon} />
        </DeleteBtn>
      )}
      <AgentImage loading={'lazy'} src={admin.avatar.url} />
      <AgentName>
        {admin.firstname} {admin.lastname}
      </AgentName>
      <AgentPhone>{admin.email}</AgentPhone>
      <AgentPhone>{admin.phone}</AgentPhone>
    </Card>
  );
};

const Card = styled.div`
  background: #ffffff;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  position: relative;
  max-width: 337px;
  padding: 30px 30px 20px 31px;
  width: calc(30.33% - 60px);
  margin: 0px 10px;
  margin-bottom: 48px;
  @media (max-width: 1000px) {
    width: calc(45% - 60px);
    margin: 0px 15px;
    margin-bottom: 48px;
  }
  @media (max-width: 700px) {
    width: 100%;
    margin: 0;
    margin-bottom: 48px;
  }
`;
const AgentImage = styled.img`
  border-radius: 100px;
  width: 82px;
  height: 82px;
  object-fit: cover;
  background-color: #c4c4c4;
  align-self: center;
`;

const AgentName = styled.p`
  align-self: center;
  font-family: Inter;
  font-size: ${pxToRem(18)};
  line-height: ${pxToRem(22)};
  text-transform: capitalize;
  font-weight: 700;
  text-align: center;
  letter-spacing: -0.005em;
  color: #27272e;
`;
const AgentPhone = styled(AgentName)`
  font-size: ${pxToRem(14)};
  line-height: ${pxToRem(23)};
  text-transform: lowercase;
  font-family: Inter;
  font-weight: 400;
  margin: 4px 0px;
`;
const DeleteBtn = styled.button`
  position: absolute;
  right: 24px;
  top: 16px;
  background-color: transparent;
  outline: none;
  border: none;
  padding: 0;
  & :hover {
    opacity: 0.6;
  }
`;
const Icon = styled.img`
  max-height: 48px;
  max-width: 48px;
`;
